export const REFRESH_INTERVAL = 10 // seconds
export const REFRESH_INTERVAL_SMALL = 5; // seconds
export const RETRY_COUNT = 3;
export const RETRY_DELAY = 2000; // milliseconds
export const TIMEOUT_ERROR = 'Generating import report timed out';
